import { Box } from '@mui/material';
import Page from 'components/templates/Page';
import EmailForm from 'components/molecules/EmailForm';
import { useStyles } from './styles';

function DidntReceiveCode() {
  const styles = useStyles();

  const title = (
    <span>
      Não recebeu o código
      <br />
      de acesso?
    </span>
  );

  const subtitle = (
    <span>
      Confira se digitou seu{' '}
      <strong>
        endereço
        <br /> de e-mail
      </strong>{' '}
      corretamente
    </span>
  );

  return (
    <Page title={title} subtitle={subtitle}>
      <Box className={styles.container}>
        <EmailForm />
      </Box>
    </Page>
  );
}

export default DidntReceiveCode;
